













import { Vue, Component } from 'vue-property-decorator';

@Component
export default class OuterLayout extends Vue {
  created () {
      this.$vuetify.theme.dark = false;
  }
}
